import styled from 'styled-components'

const Content = styled.p`
  font-size: 1rem;
  color: ${({theme}) => theme.colors.blackTwo};
`

export { Content }
